<template>
  <div id="finTech" class="header-gap bo">
    <div class="sub-banner">
      <div class="container">
        <h1 v-html="$t('finTech.banner-title')"></h1>
        <p v-html="$t('finTech.banner-desc')"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column">
          <h2>{{$t("finTech.finpoints")}}</h2>
          <p><i></i> {{$t("finTech.finpoints-desc")}}</p>
          <a href="https://www.finpoints.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/finTech_image1.png" />
        </div>
      </div>
    </div>
    <BOContactUs bocontent="finTech"/>
  </div>
  <Modals />
</template>
  
<script setup>
  import "../less/style.css"
  import Modals from '@/components/Modals/ModalMain.vue'
  import BOContactUs from '@/components/BOContactUs.vue'

  import { useHead } from '@unhead/vue'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'
  import { decodeHtml } from '@/utils'

  const { t } = useI18n()

  useHead({
    title: computed(() => decodeHtml(t('seo.fintech.title'))),
    meta: [
      { name: 'description', content: computed(() => t('seo.fintech.description')) },
      { name: 'keywords', content: computed(() => t('seo.fintech.keywords')) },
    ],
  })

  onMounted(() => {
    if (typeof document !== 'undefined')
      document.dispatchEvent(new Event('prerender-ready'))
  })

</script>

<style lang="less">
  @import '../less/mediaQuery.less';

  #finTech {
    .sub-banner {
      background:url('https://cdn.dootech.io/doo/business_overview/banner_finTech.png') no-repeat center top;
      @media @mobile-screen {
        background:url('https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/banner_finTech_mobile.png') no-repeat center top;
      }
      .container {
        @media only screen and (max-width:1500px) and (min-width:835px) {
          max-width: 40%;
          margin: 0;
        }
      }
    }
    @media only screen and (max-width:1400px) and (min-width:951px) {
      .container {
        padding:0 32px;
      }
    }
  }
</style>
